import styled from 'styled-components';

import { btn, primary } from '../base';

export const PrimayButtonC = styled.button`
  ${btn(primary)}
`;

/* The icon sat in a white rounded square behind the glyph. The design draws it
   as a bare glyph inheriting the button's own colour, so this is now just a
   sizing box. */
export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;

  svg {
    width: 15px;
    height: 15px;
  }
`;
